var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "halloweenmain" },
          [
            this.$route.query.isApp == 1
              ? _c("div", [
                  !_vm.isLoading && _vm.linkType != 3
                    ? _c("div", { staticClass: "contract-header" }, [
                        _c("div", [
                          _c("i", {
                            staticClass: "iconfont icon-xiangyou",
                            class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goBack.apply(null, arguments)
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.$route.query.isBanner == 0 && !_vm.isLoading
                    ? _c("div", { staticClass: "contract-header" }, [
                        _c("div", [
                          _c("i", {
                            staticClass: "iconfont icon-xiangyou",
                            class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goBack.apply(null, arguments)
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            this.$route.query.isApp != 1
              ? _c("InCompleteSiteHead", { staticClass: "InCompleteSiteHead" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "halloweenbackground",
                class:
                  _vm.$route.query.isApp == 1 && _vm.$route.query.isBanner != 1
                    ? "autoHeight"
                    : "",
                style: {
                  background:
                    "url(" + _vm.signconfig.bannerUrlH5 + ") no-repeat center"
                }
              },
              [
                _c("div", { staticClass: "headerdiscribe" }, [
                  _c("div", [
                    _c("p", {
                      staticClass: "banner",
                      domProps: { innerHTML: _vm._s(_vm.$t("10000001")) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "banner",
                      domProps: { innerHTML: _vm._s(_vm.$t("10000002")) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("300142")) +
                        ":" +
                        _vm._s(_vm.FixTime(_vm.signconfig.startTime)) +
                        "~" +
                        _vm._s(_vm.FixTime(_vm.signconfig.endTime)) +
                        " (UTC)\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handle("300148", 0)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("300148")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handle("300140", 1)
                          }
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("300140")) + "\n              "),
                        _c("i", {
                          class:
                            _vm.language !== "fa"
                              ? "iconfont icon-xiangyou"
                              : "iconfont icon-xiangzuo"
                        })
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "gift" }, [
              _c("div", { staticClass: "Signin" }, [
                _c("div", { staticClass: "Signinheader" }, [
                  _c("div", { staticClass: "everyday" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/anniversary/line @2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("300149")))]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/anniversary/line @2x.png"),
                        alt: ""
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "SigninMain" }, [
                  _c("p", {
                    staticClass: "describetitle",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("300147", {
                          num: _vm.timeconfig.seriesNum,
                          amount: _vm.timeconfig.amount
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "describetime" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("300150", {
                            num: _vm.$route.query.token
                              ? _vm.userMsg.signNum
                              : 0
                          })
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "signtimer" },
                    _vm._l(_vm.winList, function(item, index) {
                      return _c(
                        "dl",
                        {
                          key: index,
                          class: {
                            activeItem: _vm.userMsg.seriesNum >= index + 1
                          },
                          attrs: { id: item.isbig ? "isbig" : "" }
                        },
                        [
                          _c("dt", [
                            _c("img", {
                              attrs: {
                                src: _vm.getImgurl(
                                  _vm.$route.query.token
                                    ? _vm.userMsg.seriesNum * 1 >= item.day
                                      ? item.nosigin
                                      : item.sigined
                                    : item.sigined,
                                  ".png"
                                ),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.title) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "siginBtn" }, [
                    _vm.isstart && !_vm.isend
                      ? _c(
                          "span",
                          {
                            class: {
                              signbtn: _vm.isstart && !_vm.userMsg.isSign
                            },
                            on: {
                              click: function($event) {
                                return _vm.siginsuccess(true)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$route.query.token
                                  ? _vm.userMsg.isSign
                                    ? _vm.$t("300152")
                                    : _vm.$t("300153")
                                  : _vm.$t("300169")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isstart || _vm.isend
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("300153")))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "gosign",
                      class: { gobtn: !_vm.isstart || _vm.isend }
                    },
                    [
                      _c("a", { on: { click: _vm.tocountersign } }, [
                        _vm._v(_vm._s(_vm.$t("300156")))
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        class:
                          _vm.language !== "fa"
                            ? "iconfont icon-right"
                            : "iconfont icon-left"
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "reward" },
                [
                  _c("div", { staticClass: "everyday myStuff" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/anniversary/line @2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("300079")))]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/anniversary/line @2x.png"),
                        alt: ""
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "title" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("300142")))]),
                    _c("span", [_vm._v(_vm._s(_vm.$t("300131")))])
                  ]),
                  _vm._v(" "),
                  _vm.mystuffList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "foot" },
                        _vm._l(_vm.mystuffList, function(item, index) {
                          return _c("p", { key: index }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.FixTime(item.createTime)))
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("typeFilter")(item.type, _vm.$i18n)
                                )
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    : _c(
                        "van-empty",
                        {
                          staticClass: "custom-image",
                          attrs: { description: _vm.$t("300108") }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "icon",
                              attrs: { slot: "image", "aria-hidden": "true" },
                              slot: "image"
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-zanwujilu" }
                              })
                            ]
                          )
                        ]
                      )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            staticClass: "rewardp",
            attrs: { "close-on-click-overlay": false },
            model: {
              value: _vm.receive,
              callback: function($$v) {
                _vm.receive = $$v
              },
              expression: "receive"
            }
          },
          [
            _c("ReceiveDialog", {
              attrs: {
                receive: _vm.receive,
                closegift: _vm.siginsuccess,
                getconfig: _vm.getconfig
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-595f1bff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-595f1bff","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/anniversary.vue
// module id = SB6K
// module chunks = 0